import "../Home.css";
import "./index.css"
import React, {Component} from "react";
import _ from 'lodash'
import {request} from "../../../api-client";
import localization from "../../../config/localization";
import GlobalSnackbar, {GlobalSnackbarTypes} from "../../../components/Letflow/Snackbar/GlobalSnackbar";
import analyticsInstance from "../../../analytics/analyticsInstance";
import {Avatar, FormControl, Grid, InputLabel, MenuItem, Select} from "@material-ui/core";
import 'react-input-range/lib/css/index.css'
import qs from "qs";
import browserHistory from "../../../utils/browserHistory";
import { setPageTitle } from "../../../api-client/core/authentication/utils";
import BloomSpinner from "../../../assets/img/bloom_spinner_grey.gif";
import EventManager, {events} from "../../../utils/EventManager";
import ChipBar from "../../../components/Letflow/ChipBar";
import HomeSearchInput from "../../../components/Letflow/HomeSearchInput";
import InfiniteScroll from "react-infinite-scroll-component";
import CreationItem from "../../../components/Letflow/CreationItem";
import ContentCreationPlayer from "../../../components/Letflow/ContentCreationPlayer";
import ShareOnSocials from "../../../components/Letflow/ShareOnSocials";
import ScrollingText from "../../../components/Letflow/ScrollingText";
import Chip from "@material-ui/core/Chip";
import {Block} from "@material-ui/icons";

class SmartSearchContentCreation extends Component {

  constructor(props) {
    super(props);
    this.state = {
      tagGroups: [],
      searchResultsTags: [],
      searchResultsTitle: [],
      showTagSelection: true,
      showTagDialog: false,
      searchGroup: "contentCreation",
      type: '',
      contentCreatorId: '',
      selectedContentCreators: [],
      selectedCountry: '',
      showTags: false,
      pageReady: false,
      favorites: [],
      contentCreations: [],
      availableContentCreatorTypes: [],
      selectedFileType: "video",
      selectedCategories: [],
      selectedGlobalTags: [],
      lastPage: 0,
      currentPage: 0,
      search: "",
      showContentCreationDialog: false,
      currentPlayingContent: {},
      showShareDialog: false,
      sharingCreation: 1,
      shareToken: "",
      availableFileTypes: [
        {id: "all", name: localization.get('all')},
        {id: "video", name: localization.get('video')},
        {id: "audio", name: localization.get('audio')},
        {id: "image", name: localization.get('image')},
        {id: "binary", name: localization.get('others')},
      ]
    }
  }

  componentDidMount = () => {
    document.getElementsByTagName('html')[0].scrollTop = 0
    this.requestHasQueryParams()
      .then(() => this.requestTagGroups())
      .then(() => this.requestContentCreatorTypes())
      .then(() => this.clearUnusedTags())
      .then(() => this.setState({showTags: true}))
      .then(() => this.readQueryStringParams())
      .then(() => this.requestTracks())
    setPageTitle(localization.get('title.smart_search'))

    EventManager.getInstance().subscribe(events.ADD_TO_FAVORITE_BUTTON_PRESS, this.addToFavorites)
    EventManager.getInstance().subscribe(events.REMOVE_FROM_FAVORITE_BUTTON_PRESS, this.removeFromFavorites)

    let queryString = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
      depth: 2,
      plainObjects: true})

    if(queryString && queryString.contenido) {
      EventManager.getInstance().dispatch(events.OPEN_CONTENT_MODAL, {id: queryString.contenido.split("-")[0], dataType: "contentCreator", dataName: queryString.contenido.split("-")[1] || "contenido", onTagChange: this.handleNewSearch || false});
    }
  }

  componentWillUnmount = () => {
    EventManager.getInstance().unsubscribe(events.ADD_TO_FAVORITE_BUTTON_PRESS, this.addToFavorites)
    EventManager.getInstance().unsubscribe(events.REMOVE_FROM_FAVORITE_BUTTON_PRESS, this.removeFromFavorites)
  }

  onFavorite = (creation) => {
    if(!creation.favorite) {
      this.addToFavorites(creation.id)
    } else  {
      this.removeFromFavorites(creation.id)
    }
  }

  addToFavorites = id => {
    this.setState(state => ({
      ...state,
      searchResultsTags: state.searchResultsTags.map(creation => {
        if (creation.id === id) {
          return ({...creation, favorite: true})
        }
        return creation
      })
    }))
    request.contentCreationFavorite.add(id)
  }

  removeFromFavorites = id => {
    this.setState(state => ({
      ...state,
      searchResultsTags: state.searchResultsTags.map(creation => {
        if (creation.id === id) {
          return ({...creation, favorite: false})
        }
        return creation
      })
    }))

    request.contentCreationFavorite.remove(id)
  }


  requestHasQueryParams = () =>
    new Promise(resolve => {
      let search = qs.parse(this.props.location.search.slice(1))
      let {tags_ids, not_tags_ids, type} = search
      this.setState({type})
      if (tags_ids || not_tags_ids ) {
        this.setState({showTagSelection: false})
      }
      resolve()
    })

  readQueryStringParams = () => {
    let search = qs.parse(this.props.location.search.slice(1))
    let {tags_ids, q, selectedFileType, types} = search
    if (tags_ids || q || selectedFileType || types) {
      if (!q) q="";
      types = types ? types.split(',') : [];
      if (!selectedFileType) selectedFileType="video";

      this.setState({
        selectedCategories: types,
        search:q,
        selectedFileType:selectedFileType
      })
    }
  }

  writeQueryStringParams = () => {
    let {selectedCategories, search, selectedFileType, selectedGlobalTags} = this.state
    browserHistory.push({
      pathname: window.location.pathname,
      search: qs.stringify({
        selectedFileType: selectedFileType,
        types: selectedCategories.join(','),
        tags_ids: selectedGlobalTags.filter(tag => tag.selectedTag !== "0").map(tag => tag.selectedTag).join(','),
        q: search,
      })
    })
  }

  markTagAsSelected = tagId => new Promise(resolve => {
    const tags = _.flatMap(this.state.tagGroups, tagGroup => tagGroup.tags)
    const tag = _.find(tags, tag => tag.id.toString() === tagId.toString())
    if (tag) {
      tag.state = 'selected'
    }
    this.forceUpdate(() => resolve({}))
  })

  markTagAsUnselected = tagId => new Promise(resolve => {
    const tags = _.flatMap(this.state.tagGroups, tagGroup => tagGroup.tags)
    const tag = _.find(tags, tag => tag.id.toString() === tagId.toString())
    if (tag) {
      tag.state = 'unselected'
    }
    this.forceUpdate(() => resolve({}))
  })

  requestTagGroups = () =>  {
    let paginationConfig = {filterBy: [{ column: 'creation', filter: 1}, { column: 'content_creations', filter: true}, {column: "is_global", filter: true}]}
    if (this.state.type) {
      paginationConfig = {...paginationConfig, filterBy: paginationConfig.filterBy.concat([
        { column: 'type', filter: `${this.state.type}`}
        ])}
    }
    return request.tagGroup.getAll(paginationConfig)
      .then(tagGroups => {
          const selectedTags = tagGroups.map(tg => ({tagGroupId: tg.id, selectedTag: "0"}))

          this.setState({ tagGroups: tagGroups, selectedGlobalTags: selectedTags })
      })
  }


  getSelectedTags = () =>  this.state.tagGroups.reduce((tags, tagGroup) => tags.concat(tagGroup.tags), []).filter(tag => tag.state === 'selected')
  getUnselectedTags = () =>  this.state.tagGroups.reduce((tags, tagGroup) => tags.concat(tagGroup.tags), []).filter(tag => tag.state === 'unselected')

  clearUnusedTags = () => {
    this.setState(state => ({
      ...state,
      tagGroups: state.tagGroups.map(tgs => ({
        ...tgs,
        tags: tgs.tags.filter(tag => tag.state !== 'disable')
      }))
    }))
  }

  requestContentCreatorTypes = () => {
    const filters = [
        {column: "creations", filter: "1"},
        {column: "type", filter: "talent"},
        {column: "smartSearch", filter: "true"},
        {column: "tags", filter: this.state.selectedGlobalTags.filter(tag => tag.selectedTag !== "0").map(tag => tag.selectedTag)},
      ]
    if (this.state.selectedFileType !== "all") filters.push({column: "content_type", filter: this.state.selectedFileType})

    return request.contentCreatorType.getAll({filterBy: filters})
      .then(availableContentCreatorTypes => {
      this.setState({ availableContentCreatorTypes: availableContentCreatorTypes })
    })
  }

  disableAllTagsForRequest = () => {
    this.setState(state => ({
      ...state,
      tagGroups: state.tagGroups.map(tgs => ({
        ...tgs,
        tags: tgs.tags.map(tag => ({
          ...tag,
          state: 'disable'
        }))
      }))
    }))
  }

  getSearchTags = () => this.state.tagGroups.reduce((tags, tagGroup) => tags.concat(tagGroup.tags), []).filter(tag => tag.state === 'selected').map(tag => tag.id)

  requestTracks = ({
       searchTags = this.getSearchTags(),
       type = this.state.selectedFileType,
       types = this.state.selectedCategories,
       page = 0,
       clearResults = true
     } = {}) => {
    return request.contentCreation.getAllWithTags(
      type,
      this.state.selectedGlobalTags.filter(tag => tag.selectedTag !== "0").map(tag => tag.selectedTag),
      [],
      this.state.search,
      types.filter(categoryId => this.state.availableContentCreatorTypes.map(type => type.id).includes(parseInt(categoryId))),
      {perPage: 16, page: page}
    ).then(searchResults => {
      let results = searchResults.data

      if(!clearResults) {
        results = this.state.searchResultsTags.concat(searchResults.data)
      }

      this.setState({
        searchResultsTags: results,
        showTagSelection: false,
        contentCreators: searchResults.data.map(content => content.contentCreator),
        lastPage: searchResults.meta.last_page,
        currentPage: searchResults.meta.current_page,
        total: searchResults.meta.total,
      })
      const searchTagsNames = this.state.tagGroups.flatMap(x => x.tags).filter(x => searchTags.includes(x.id)).map(x => x.name)
      analyticsInstance.smartSearch(searchTagsNames)
    })
      .then(() => this.setState({pageReady: true}))
      .catch(e=> {
        GlobalSnackbar.show({
          message: 'smart_search_request_failed',
          type: GlobalSnackbarTypes.ERROR,
        })
      })
  }

  renderSelectors = () => {
    return (
      <div style={{width: "100%", display: "flex", justifyContent: "space-between", margin: "70px 0px 20px", flexWrap: "wrap"}}>
        <FormControl className="smart-search-selector-control" style={{marginBottom: 10}}>
          <InputLabel className="smart-search-selector-label" style={{fontSize: 19, textTransform: "uppercase", color: "black", position: "absolute", fontWeight: "bold"}}>{localization.get('smart_search.file_type')}</InputLabel>
          <Select
            disableUnderline
            value={this.state.selectedFileType}
            style={{border: "1px solid #ccc", textAlign: "left", padding: "0 5%", color: "#6a6a6a",}}
            onChange={(e) => this.setState({selectedFileType: e.target.value}, this.onChangeFilters)}
          >
            {this.state.availableFileTypes.map(fileType =>
              <MenuItem value={fileType.id} style={{color: "#6a6a6a"}}>{fileType.name}</MenuItem>
            )}
          </Select>
        </FormControl>
        {this.state.tagGroups.length > 0 && this.state.tagGroups.slice(0, 3).map(tagGroup =>
          <FormControl className="smart-search-selector-control" style={{marginBottom: 10}}>
            <InputLabel className="smart-search-selector-label" style={{fontSize: 19, textTransform: "uppercase", color: "black", position: "absolute", fontWeight: "bold"}}>{tagGroup.name}</InputLabel>
            <Select
              disableUnderline
              value={this.state.selectedGlobalTags.find(selectedTag => selectedTag.tagGroupId === tagGroup.id) ? this.state.selectedGlobalTags.find(selectedTag => selectedTag.tagGroupId === tagGroup.id).selectedTag : "0"}
              style={{border: "1px solid #ccc", textAlign: "left", padding: "0 5%", color: "#6a6a6a"}}
              onChange={(e) => {
                let newSelectedGlobalTags = this.state.selectedGlobalTags.filter(selectedTag => selectedTag.tagGroupId !== tagGroup.id)
                newSelectedGlobalTags.push({tagGroupId: tagGroup.id, selectedTag: e.target.value})
                this.setState({selectedGlobalTags: newSelectedGlobalTags}, this.onChangeFilters)
              }}
            >
              <MenuItem value="0" style={{color: "#6a6a6a"}}>{localization.get("all")}</MenuItem>
              {tagGroup.tags.map(tag =>
                <MenuItem value={tag.id} style={{color: "#6a6a6a"}}>{tag.name}</MenuItem>
              )}
            </Select>
          </FormControl>
        )}
      </div>
    )
  }

  onCategoriesSelectedChange = categoryId => {
    let currentCategories = this.state.selectedCategories
    if (currentCategories.includes(categoryId)) {
      return this.setState({selectedCategories: currentCategories.filter(cat => cat !== categoryId)}, () => {
        this.writeQueryStringParams()
        this.requestTracks()
      })
    }

    currentCategories.push(categoryId)
    return this.setState({selectedCategories: currentCategories}, () => {
      this.writeQueryStringParams()
      this.requestTracks()
    })
  }

  clearCurrentPlayingContent = () => {
    this.setState({showContentCreationDialog: false, hasPrev: false, hasNext: false, currentIndex: null, currentPlayingContent: {}})
  }

  setCurrentPlayingContent = (index) => {
    let hasPrev = index > 0 ;
    let hasNext = index < (this.state.searchResultsTags.length - 1);
    this.setState({showContentCreationDialog: true, currentPlayingContent: this.state.searchResultsTags[index], hasPrev: hasPrev, hasNext: hasNext, currentIndex: index})
  }

  onChangeFilters = () => {
    this.requestContentCreatorTypes()
      .then(this.requestTracks)
      .then(this.writeQueryStringParams)
  }

  renderCategories = () =>
    <ScrollingText
      text={this.state.availableContentCreatorTypes.map((chip, j) =>
        <div className={`smart-search-tag-containter`}
             style={{position: "relative", float: "left", margin: "0px 5px"}}>
          {chip.state !== 'disable' ?
            <Chip
              key={j}
              avatar={chip.state === 'unselected' &&
              <Avatar style={{width: 23, height: 23, backgroundColor: "rgb(208, 55, 55)"}}>
                <Block style={{color: "white"}}/>
              </Avatar>
              }
              style={{
                width: "auto",
                fontWeight: "400",
                backgroundColor: this.state.selectedCategories.includes(chip.id.toString()) ? 'black' : 'white',
                color: this.state.selectedCategories.includes(chip.id.toString()) ? 'white' : 'black',
                cursor: 'pointer',
                height: "30px",
                marginTop: "3px",
                marginBottom: "3px",
                border: !['selected', 'unselected'].includes(chip.state) && '1px solid #c0c0c0',
              }}
              className={"chip-bar-chips"}
              label={<span style={{
                color: this.state.selectedCategories.includes(chip.id.toString()) ? "white" : "rgb(110 110 110)",
                letterSpacing: -0.5,
                fontSize: 11
              }}>{chip.name}</span>}
              onClick={(e) => this.onCategoriesSelectedChange(chip.id.toString())}
            /> :
            <Chip key={j}
                  style={{
                    width: "auto",
                    fontWeight: "400",
                    backgroundColor: 'transparent',
                    color: 'rgba(191,191,191,0.55)',
                    cursor: 'default',
                    height: "30px",
                    marginTop: "3px",
                    marginBottom: "3px",
                    border: '1px solid #e9e9e9',
                  }}
                  className={"chip-bar-chips"}
                  label={<span style={{
                    color: this.state.selectedCategories.includes(chip.id.toString()) ? "white" : "rgb(110 110 110)",
                    letterSpacing: -0.5,
                    fontSize: 11
                  }}>{chip.name}</span>}
            />
          }
        </div>
      )}
    />

  handleSearchInputKeyPress = () => {
    this.interval && clearInterval(this.interval)
    this.interval = setTimeout(() => {
      if(this.state.search.length > 2 || this.state.search.length === 0) {
        this.writeQueryStringParams();
        this.requestTracks();
      }
    }, 200)
  };



  render = () => {
    if (!this.state.pageReady){
      return (
        <div style={{ height: "100%", display: "flex", justifyContent: "center", alignContent: "center" }}>
          <img style={{width: 100, height: 100, marginTop: "calc(43vh - 30px)"}} src={BloomSpinner} alt="Loading logo"/>
        </div>
      )
    } else {
      return (
        <div className="smart-search-category-container">
          <ShareOnSocials
            show={this.state.showShareDialog}
            handleClose={() => this.setState({showShareDialog: false})}
            url={`${window.location.protocol}//${window.location.hostname}/public/content_creations/${this.state.shareToken}`}
            darkMode={true}
            shareToken={this.state.shareToken}
          />
          <ContentCreationPlayer
            show={this.state.showContentCreationDialog}
            onNextArrow={this.state.hasNext ? () => this.setCurrentPlayingContent(this.state.currentIndex+1) : null}
            onPrevArrow={this.state.hasPrev ? () => this.setCurrentPlayingContent(this.state.currentIndex-1) : null}
            currentContentCreation={this.state.currentPlayingContent}
            handleClose={() => this.clearCurrentPlayingContent()}
          />
          <HomeSearchInput
            value={this.state.search}
            placeholder={"searchbar.input_content"}
            onSearch={value => this.setState({search: value}, this.handleSearchInputKeyPress)}
          />
          {this.renderSelectors()}

          {this.state.availableContentCreatorTypes.length > 0 && this.renderCategories()}
          {this.state.searchResultsTags.length > 0 ?
            <InfiniteScroll
              style={{display: "flex", flexWrap: "wrap", position: "relative", float: "left", width: "100%"}}
              dataLength={this.state.searchResultsTags.length}
              next={() => this.requestTracks({page: this.state.currentPage++, clearResults: false})}
              hasMore={this.state.currentPage < this.state.lastPage}
              loader={<div
                style={{height: "70px", paddingTop: 20, width: "100%", display: "flex", justifyContent: "center", alignContent: "center"}}
              >
                <img style={{width: 50, height: 50}} src={BloomSpinner} alt="Loading logo"/>
              </div>}
            >
              <Grid  container fullWidth>
                {this.state.searchResultsTags.map((creation, key) =>
                  <Grid key={key} xs={12} sm={6} md={4} lg={3} xl={3} item style={{padding: 10, width: "100%"}}>
                    <CreationItem
                      contentCreation={creation}
                      onFavorite={() => this.onFavorite(creation)}
                      onPlay={() => this.setCurrentPlayingContent(key)}
                      onShare={id => request.contentCreation.share(id)
                        .then(response => this.setState({
                          showShareDialog: true,
                          shareToken: response.code,
                          sharingCreation: id
                        }))
                      }
                    />
                  </Grid>
                )}
              </Grid>
            </InfiniteScroll>
            :
            <div style={{position: "relative", float: "left", width: "100%", padding: "100px 0"}}>
              <p style={{color: "#ccc", fontSize: 32, fontWeight: "bold", textAlign: "center"}}>{localization.get('smart_search.no_result')}</p>
            </div>
          }

        </div>
      )
    }
  }
}

export default SmartSearchContentCreation;
